module.exports = __webpack_public_path__ + "img/01_ionization_(white).53870c1f.svg";